import { render, staticRenderFns } from "./MdtfAddMain.vue?vue&type=template&id=baaa1a8a&scoped=true&"
import script from "./MdtfAddMain.vue?vue&type=script&lang=js&"
export * from "./MdtfAddMain.vue?vue&type=script&lang=js&"
import style0 from "./MdtfAddMain.vue?vue&type=style&index=0&id=baaa1a8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baaa1a8a",
  null
  
)

export default component.exports